import md5 from 'crypto-js/md5'

export default function getFilialYmlFeedLink (filialId, baseUrl) {
  const hash = md5(`filial.id.${filialId}`)
  return `${baseUrl}/feed/yaml/${filialId}/${hash}`
}
